import i18n from "../i18n/config";

function t(key, options) {
  return i18n.t(key, { ns: "settings", ...options });
}

/**
 * Corpo útil do erro da API (fetchData rejeita com response.data; axios usa error.response.data).
 * Não use error.data sozinho: em respostas { message, data: "claimed_by=..." }, data é string auxiliar.
 */
export function normalizeApiErrorBody(error) {
  const fromAxios = error?.response?.data;
  if (fromAxios && typeof fromAxios === "object" && !Array.isArray(fromAxios)) {
    return fromAxios;
  }
  if (
    error &&
    typeof error === "object" &&
    !Array.isArray(error) &&
    typeof error.message === "string"
  ) {
    return error;
  }
  return {};
}

/** Parseia strings tipo "claimed_by=xvision" ou "a=1&b=2". */
export function parseKeyValueDataString(s) {
  if (typeof s !== "string" || !s.trim()) return {};
  const out = {};
  for (const part of s.split("&")) {
    const idx = part.indexOf("=");
    if (idx === -1) continue;
    const key = part.slice(0, idx).trim();
    const val = part.slice(idx + 1).trim();
    if (key) out[key] = val;
  }
  return out;
}

/**
 * Mensagem completa para falha ao salvar canal (POST/PUT): texto da API + orientação quando houver dados extras.
 */
export function buildChannelSaveErrorMessage(error) {
  const raw = normalizeApiErrorBody(error);
  let serverMessage =
    (typeof raw.message === "string" && raw.message.trim()) ||
    (typeof raw.error === "string" && raw.error.trim()) ||
    null;

  if (typeof serverMessage === "string") {
    if (serverMessage.includes("Column 'id_projeto'")) {
      return t("channelsPage.saveErrorNeedCompany");
    }
    if (serverMessage.includes("Column 'id_tipo'")) {
      return t("channelsPage.saveErrorNeedDefaultType");
    }
  }

  if (raw.code === "DOMAIN_CLAIMED_BY_OTHER_WORKSPACE") {
    const fromObj =
      raw.data && typeof raw.data === "object" && !Array.isArray(raw.data)
        ? raw.data.claimedBy || raw.data.claimed_by
        : null;
    const main = serverMessage || t("channelsPage.saveErrorGeneric");
    if (fromObj) {
      const hint = t("channelsPage.saveErrorEmailDomainClaimedHint", {
        workspace: String(fromObj),
      });
      return `${main}\n\n${hint}`;
    }
    return main;
  }

  const dataStr = typeof raw.data === "string" ? raw.data : "";
  const parsed = parseKeyValueDataString(dataStr);
  const claimedBy = parsed.claimed_by || parsed.claimedBy;

  const main =
    serverMessage || t("channelsPage.saveErrorGeneric");

  if (claimedBy) {
    const hint = t("channelsPage.saveErrorMetaClaimedHint", {
      workspace: claimedBy,
    });
    return `${main}\n\n${hint}`;
  }

  return main;
}

/**
 * Mensagem única para qualquer falha de API (ex.: DELETE, PUT) quando o backend envia { message } no corpo.
 */
export function getApiErrorDisplayMessage(error, fallbackI18nKey) {
  const raw = normalizeApiErrorBody(error);
  const msg =
    (typeof raw.message === "string" && raw.message.trim()) ||
    (typeof raw.error === "string" && raw.error.trim()) ||
    null;
  if (msg) return msg;
  return t(fallbackI18nKey);
}
